module.exports = __webpack_public_path__ + "img/icon_success.e64a5051.png";